import * as React from 'react';
import DdActionBlock from './DdActionBlock';
import QuotationsList from './QuotationsList'
import PotMeasuresList from  './PotMeasuresList'
import Expander_helper from './Expander_helper'
import ImplementationList from './ImplementationList'
import Styled_label from './Styled_label'


interface MyProps {
    options:any,
    without_buildingparts_view:boolean,
    post_id:string,
    view:string,
    level1cluster:any,
    cb_parent: (e: any, cb: (r: any) => void) => void,
    permissions:any,
    stup:any,
    tup:any
}
type MyState = {
    measures: {[aid:string]:any}    
    new_measure: boolean  // after a new measure was added, to force expander
    oordeel_huidig:string
    is_loading:boolean
}
class SubTopicBuildingPart extends React.PureComponent<MyProps,MyState> {
    constructor(props: MyProps) {
        super(props)
	this.handle_cb = this.handle_cb.bind(this)
	this.state = {
	    is_loading:false,
	    oordeel_huidig:'',
	    new_measure:false,
	    measures:{}

	}
    }
    componentDidMount(){
	let tup = this.props.tup
	if(tup.tup.advises){
	    this.setState({ measures: tup.tup.advises})
	}
	let oordeel = this.get_oordeel_huidig()
	if(oordeel !== undefined ){
	    this.setState({oordeel_huidig: oordeel})
	}
    }
    handle_cb(e:any, cb:(r:any)=>void){
	console.log('handle-cb cmd: '+e.cmd)
	if(e.cmd === "set-action-status"){
	    if(e.acf_field !== undefined && e.acf_field.name === "oordeel" && e.aspect === "huidig"){
		console.log('setstate : '+e.winner)
		this.setState({oordeel_huidig: e.winner})
	    }

	    console.log(e)
	}
	this.props.cb_parent(e,(r:any) => {
	    console.log('return from cb-parent')
	    if(r.bd_advise){
		let new_aid = r.value
		let new_tup = r.bd_advise[new_aid]
		if(new_tup !== undefined){
		    let tup : {[k:string]:any}= {}
		    tup[new_aid] = new_tup
		    this.setState(prevState => ({
			new_measure: true,
			measures: {...prevState.measures, ...tup}
		    }))
		}
	    }
	    if(r.winner_changed){
		if(r.aspect === "huidig" && r.acf_field.name === "oordeel"){
		    let v = r.winner
		    this.setState({oordeel_huidig: e.winner})
		}
	    }
	    cb(r)
	})

    }
    
    get_bouwdeel(){
	return {
	    label: this.get_buildingpart_label(),
	    slug: this.props.tup.slug
	}
    }
    get_l2cluster(){
	return {
	    name: this.props.stup.name,
	    label: this.props.stup.label
	}
    }
    is_expanded(){
	let name = this.props.tup.slug
	if(this.props.options.config !== null){
	    let conf = this.props.options.config
	    if(conf.bd !== undefined){
		return conf.bd === name
	    }
	}
	return false
    }

    /*
     *  list of archived Implementations not organised by PotMeasures  
     **/
    render_implementations(){
        if(this.props.options.config !== null){
            let conf = this.props.options.config
            if(conf.block_ui_type === "simple"){
                return
            }
        }
	let list = this.props.tup.tup.implementations 
	if(list.length === 0){return null}
        let opt = this.props.options.repeater_blocks
        opt.config = this.props.options.config

        let expand_this = opt.config.mtype === "implementation"

        return  <ImplementationList
                    expanded={expand_this}
                    context={"level2cluster"}
                    implementations={list}
                    l2cluster={this.get_l2cluster()}
                    l1cluster={this.props.level1cluster}
                    permission={this.props.permissions}
                    bouwdeel={this.get_bouwdeel()}
                    options={opt}
                    postid={Number(this.props.post_id)}
                    cb_parent={this.props.cb_parent}
                 />

    }

    /*
     *  list of Quotations not organised by PotMeasures  
     **/
    render_quotations(){
	let list = this.props.tup.tup.quotations.filter((x:any) => Number(x.linked_attr) === 0)
	let archive_mode = false // archive-mode
	if(this.with_potmeasures()){
	    archive_mode = true
	    // check if there are orphaned quotations
	    if(list.length === 0){
		return null
	    }
	}

	if(!this.props.level1cluster.classes.includes('l2quotations')){
	    return null
	}
	if(this.props.stup.classes !== undefined){
	    if(this.props.stup.classes.includes("no-l2quotations")){
		return null
	    }
	}
	let opt = this.props.options.repeater_blocks
	opt.config = this.props.options.config

	let expand_this = opt.config.mtype === "quotation"
	return  <QuotationsList
		    expanded={expand_this}
		    quotations={list}
		    l2cluster={this.get_l2cluster()}
		    l1cluster={this.props.level1cluster}
		    permission={this.props.permissions}
		    readonly={archive_mode}
		    bouwdeel={this.get_bouwdeel()}
		    options={opt}
		    postid={Number(this.props.post_id)}
		    cb_parent={this.props.cb_parent}
		 />

    }
    with_potmeasures(){
	if(this.props.view === "ddquotations"){return false}
	if(!this.props.level1cluster.classes.includes('l2potmeasures')){
	    return false
	}
	if(this.props.stup.classes !== undefined &&
	    this.props.stup.classes.includes('no-potmeasures')){
	    return false
	}
	return true
    }
    render_pot_measures(mode:string){
	if(! this.with_potmeasures()){
	    return null
	}
	if(mode === "choice"){
	    let l1classes = this.props.level1cluster.classes
	    if(! l1classes.includes('l2quotations')){
		return null
	    }
	}

	let opt = this.props.options.repeater_blocks
	opt.config = this.props.options.config
	// in deeplink situation, force expander state
	let expand_this = opt.config.mtype === "potmeasure"
	if(mode === "all" && this.state.new_measure){
	    expand_this=true
	}
	// react-key will update when state.measures is changed
	let react_key = mode + "-"+Object.keys(this.state.measures).join(",")
	let quo_list = mode === "all" ? [] : this.props.tup.tup.quotations
	let imp_list = mode === "all" ? [] : this.props.tup.tup.implementations

	
	return <PotMeasuresList key={react_key}
		   expanded={expand_this}
		   oordeel_is_empty={this.get_oordeel_is_empty()}
		   l2cluster={this.get_l2cluster()}
		   l1cluster={this.props.level1cluster}
		   permission={this.props.permissions}
		   bouwdeel={this.get_bouwdeel()}
		   measures={this.state.measures}
		   options={opt}
		   quotations={quo_list}
		   implementations={imp_list}
		   mode={mode}
		   postid={Number(this.props.post_id)}
		   cb_parent={this.handle_cb}
	/>

    }

    // l2tup : item from stup.fields
    render_l2_block(acf_field:any,j:number,l2c:any){
	if(acf_field.classes === undefined
	  ||acf_field.classes === null){ return null  }
	if(this.props.view === "ddquotations"){return null}
	let l2tup : {[k:string]:any} = {}
	let show_in_building_measures = [ "oordeel","uitvoering_van"]
	if(this.props.view === "buildingmeasures" 
	   && ! show_in_building_measures.includes(acf_field.name)){
	    return null
	}
	if(this.props.stup.classes !== undefined){
	    let check = "no-"+acf_field.name
	    if(this.props.stup.classes.includes(check)){
		return null
	    }
	}
	let bd = this.props.tup
	let bdtup :  {[name:string]:any} = {
	    slug: this.props.tup.slug,
	    label: this.get_buildingpart_label()
	}
	for( var aspect of ['huidig','voorstel']) {
	    // set empty acf-field as default
	    l2tup[aspect] = acf_field[aspect]
	}
	for(var k of ['key','label','name','classes']){
	    l2tup[k] = acf_field[k]
	}

	if('tup' in bd){
	    let field_key = acf_field.key
	    // merge properties from acf_field and bd.tup
	    if(field_key in bd.tup){
		let bd_field_tup = bd.tup[field_key]
		for( var aspect of ['huidig','voorstel']) {
		    if(bd_field_tup[aspect].row !== undefined){
			let row = bd_field_tup[aspect].row
			l2tup[aspect] = row // overwrite the empty acf_field
			l2tup[aspect].comments = bd_field_tup[aspect].comments
			l2tup[aspect].comment_count = bd_field_tup[aspect].comments.length
			for(var kk of ['buttons','choices','select','active']){
			    l2tup[aspect][kk] = acf_field[aspect][kk]
			}
			let v = row.value
			let have_value = v !== undefined && v !== "" && v!== "kies"
			l2tup[aspect].value_count = have_value ? "1" : "0"
		    }
		}
	    }
	}
	

	if(acf_field.classes.includes('with-adviseur')){
	    console.log('class with adviseur')
	    let akey = this.get_key_adviseur()
	    if(akey){
		console.log(` key adviseur ${akey}`)
		//let zwakey = this.get_props.options.zw_adviseur.key
		bdtup.adviseur = bd.tup[akey]
	    }
	}
	console.log(bdtup)
	if(acf_field.classes.includes('verborgen')){
	    return null
	}

	return (
	    <DdActionBlock
	    options={this.props.options}
		l2cluster={l2c}
		bptup={bdtup}
	    cb_parent={this.handle_cb}
	    permission={this.props.permissions}
	    key={j} tup={l2tup} post_id={this.props.post_id} />
	)
    }
    get_key_adviseur(){
	for(var x of this.props.stup.fields){
	    if(x.name === 'adviseur'){
		return x.key
	    }
	}
    }
    /*
     *  part: (1 or 2)
     *    part=1: show all rows except with class bottom
     *    part=2: show only the rows with class bottom
     */
    render_l2_blocks(part:number){
	let stup = this.props.stup
	let l2c = { label : stup.label, name: stup.name}
	return (
	    <div className="steps">
		{stup.fields.map((acf_field:any, j:number) => {
		    if(acf_field.classes !== undefined && acf_field.classes.includes('bottom')){
			if(part == 1){ return null }
		    }else{
			if(part == 2){return null}
		    }
		    return this.render_l2_block(acf_field,j,l2c)
		})}
	    </div>
	)
    }
    get_oordeel_is_empty() :boolean{
	let ret = this.state.oordeel_huidig
	return (ret === '' || ret === "kies")
    }
    get_oordeel_huidig() : string{
	let level1_tup = this.props.stup
	let oordeel_huidig_l1 = level1_tup.oordeel_huidig
	if(typeof oordeel_huidig_l1 === "string"){
	    return oordeel_huidig_l1
	}
	let ret = "kies"
	level1_tup.fields.forEach((tup:any, _j:number) => {
	    if(tup.name === "oordeel"){
		let acf = tup.key
		if(this.props.tup.tup !== undefined){
		    let ftup = this.props.tup.tup[acf]
		    if(ftup !== undefined){
			ret = ftup.huidig.row.value
		    }
		}
	    }
	})
	return ret
    }

    get_choices(){
	let opt = this.props.options.repeater_blocks
	let buttons = opt.buildingparts.buttons
	let ret :{[name:string]:string}={}
	for(var x of buttons){
	    ret[x.name] = x.label
	}
	return ret
    }
    get_buildingpart_label(){
	let choices = this.get_choices()
	return choices[this.props.tup.slug]
    }
    render_main_body(){
	return (
	    <div>
		    {this.render_l2_blocks(1)}
		    {this.render_pot_measures('all')}
		    {this.render_pot_measures('choice')}
		    {this.render_quotations()}
		    {this.render_implementations()}
		    {this.render_l2_blocks(2)}
	    </div>
	)
    }
    render(){
	let highlight = this.is_expanded() ? "highlight" : ""
	let exp = new Expander_helper()
	if(this.props.without_buildingparts_view){
	    return (
		<div className="buildingpart">
		  {this.render_main_body()}
		</div>
	    )
	}
	let l2label = this.props.stup.label
	let parts = {
	    pre: '',
	    subtopic: l2label,
	    buildingpart: this.get_buildingpart_label()
	}

	let bp_label =(
	    <div className="label text-blue"><Styled_label template="subtopic-building" parts={parts} /></div>
	)

	//let l1label = this.props.level1cluster.label
	let hdr_class = ""

	if(this.props.tup.slug === "hele_woning"){
	    /*
	     * "Geef hieronder aan, voor [SUB-TOPIC] wat het i) Oordeel van de huidige staat is; ii) wat de (potentiele) Maatregelen zijn; iii) welke Offertes je daarvoor wilt / hebt en hoe het met de Uitvoering staat. 
LET OP: In dit bovenste blok kun je dit aangeven voor je woning in het algemeen; optioneel kun je verderop naar onder dit doen voor een Woningonderdeel."
	     */
	    bp_label = (
		<div className="text-blue">
		<p>Geef hieronder aan, voor <b>{l2label}</b>, 
		    wat het i) Oordeel van de huidige staat is;
		    ii) wat de (potentiële) Maatregelen zijn;
		   iii) welke Offertes je daarvoor wilt / hebt en hoe het met de Uitvoering staat. </p>
		<p> In dit bovenste blok kun je dit aangeven voor je woning in het algemeen; optioneel
		   kun je verderop naar onder dit doen voor een Woningonderdeel. </p>
		</div>
	    )
	}

	let oordeel_status = this.get_oordeel_is_empty() ? "leeg" : "niet-leeg"

	return (
	    <div className={"buildingpart "+highlight}>
		<div className={"header "+hdr_class}>
		    <div className="pre-icon"></div>
		    {bp_label}
		</div>
		<div className={"body oordeel-"+oordeel_status}>
		  {this.render_main_body()}
		</div>
	    </div>
		
	)

    }
}
export default SubTopicBuildingPart
